"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var form_group_with_select_1 = require("../components/form_group_with_select");
var shipping_region_1 = require("./shipping_region");
var ShippingRegionSelector = /** @class */ (function (_super) {
    tslib_1.__extends(ShippingRegionSelector, _super);
    function ShippingRegionSelector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ShippingRegionSelector.prototype, "subregionOptions", {
        get: function () {
            return shipping_region_1.SUBREGION_CODES.map(function (code) {
                return { text: shipping_region_1.subregionName(code), value: code };
            });
        },
        enumerable: true,
        configurable: true
    });
    ShippingRegionSelector.prototype.countryIsNotUS = function (country) {
        return country.countryCode !== 'US';
    };
    Object.defineProperty(ShippingRegionSelector.prototype, "countryOptions", {
        get: function () {
            return this.props.countries.filter(this.countryIsNotUS).map(function (country) {
                return { text: country.name, value: country.countryCode };
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShippingRegionSelector.prototype, "optionGroups", {
        get: function () {
            return [
                { options: this.subregionOptions, key: 'subregions' },
                { options: this.countryOptions, key: 'countries' },
            ];
        },
        enumerable: true,
        configurable: true
    });
    ShippingRegionSelector.prototype.render = function () {
        return (React.createElement(form_group_with_select_1.default, { id: "shippingRegionCode", inputName: "shippingRegionCode", label: I18n.t('commons.offers.location.shippingRegionLabel'), updateField: this.props.onChange, value: this.props.value || '', required: true, addEmptyOption: true, optionGroups: this.optionGroups, autoFocus: true }));
    };
    return ShippingRegionSelector;
}(React.Component));
exports.default = ShippingRegionSelector;
//# sourceMappingURL=shipping_region_selector.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/shipping_region_selector.js
// module id = 3Hrf
// module chunks = 20 21